import React, { Fragment } from 'react';
import { Header } from 'semantic-ui-react';
import ManageAddressesTab from './ManageAddressesTab';

const ManageBlackWhiteListPage: React.FC = () => (
    <Fragment>
        <Header as="h1" className="reportHeader">
            Settings
        </Header>
        <ManageAddressesTab />
    </Fragment>
);

export default ManageBlackWhiteListPage;
